import OutreachDuePage from "../features/crm/OutreachDuePage";

export default function CrmDueTodayRoute() {
  return <OutreachDuePage />;
}
